export const prepareAddUserFormData = (formValues) => {
  const formData = new FormData();
  Object.entries(formValues).forEach(([key, value]) => {
    // Skip profile_pic and id_proof
    if (key === "profile" || key === "id_proofPic") {
      return;
    }
    // Handle array values
    if (Array.isArray(value)) {
      value.forEach((item) =>  formData.append(`${key}`, item));
    } else if (value !== "" && value !== null && value !== undefined) {
      // Append only non-empty, non-null, and defined values
      formData.append(key, value);
    }
  });
  return formData;
};
